/**
 *
 * @enum ViewerEventType
 *
 * the kinds of events we can emit
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2023
 *
 */

export enum ViewerEventType {
  ENTER_FULLSCREEN='ENTER_FULLSCREEN',
  EXIT_FULLSCREEN='EXIT_FULLSCREEN',
  NEW_MODEL='NEW_MODEL',
  LOAD_ERROR='LOAD_ERROR',
  KEY_DOWN='KEY_DOWN',
  KEY_UP='KEY_UP',
  SINGLE_CLICK='SINGLE_CLICK',
  DOUBLE_CLICK='DOUBLE_CLICK',
  MOUSE_DOWN='MOUSE_DOWN',
  MOUSE_UP='MOUSE_UP',
  MOUSE_WHEEL='MOUSE_WHEEL',
  CONTEXT_MENU='CONTEXT_MENU',
  IDLE='IDLE',
  RESIZE='RESIZE',
  ZOOM='ZOOM',
  ZOOM_START='ZOOM_START',
  ZOOM_END='ZOOM_END',
  PAN='PAN',
  PAN_START='PAN_START',
  PAN_END='PAN_END',
  DRAG='DRAG',
  DRAG_START='DRAG_START',
  DRAG_END='DRAG_END',
  NONE='NONE'
}

/** short cut for the various kinds of browser events we support */
export type BrowserEventType = MouseEvent|TouchEvent|WheelEvent|KeyboardEvent|null;
